import { roundToTwoDecimals } from './mathHelpers.js';

export const applyFranchiseToIntervals = (intervals, franchise) => {
  if (!franchise || franchise <= 0 || !intervals || intervals.length === 0) {
    return intervals;
  }

  const newIntervals = [];

  intervals.forEach(interval => {
    const {
      plafondMin,
      plafondMax,
      value
    } = interval;

    // Si l'intervalle est entièrement dans la période de franchise, on le garde tel quel
    if (plafondMax <= franchise) {
      newIntervals.push(interval);
      return;
    }

    // Si l'intervalle est entièrement après la période de franchise, on le garde tel quel
    if (plafondMin > franchise) {
      newIntervals.push(interval);
      return;
    }

    if (plafondMin <= franchise && plafondMax > franchise) {
      newIntervals.push({
        plafondMin,
        plafondMax: franchise,
        value,
        label: `${plafondMin} à ${franchise} jours`
      });

      newIntervals.push({
        plafondMin: franchise + 1,
        plafondMax,
        value,
        label: `${franchise + 1} à ${plafondMax} jours`
      });
    }
  });

  return newIntervals;
};

export const calculateHealthInsurancesWithFranchise = (
  intervals,
  ROs,
  baseAmount,
  isAboveOnePASS,
  franchise
) => {
  if (!intervals || intervals.length === 0) {
    return [];
  }

  return intervals.map((interval, index) => {
    const roValue = parseFloat(ROs[index]) || 0;

    if (franchise && franchise > 0 && interval.plafondMax <= franchise) {
      return '0';
    }

    if (isAboveOnePASS) {
      const rcAmount = Math.max(0, baseAmount - roValue);
      return roundToTwoDecimals(rcAmount).toString();
    }

    return roundToTwoDecimals(baseAmount).toString();
  });
};
